module.exports = __webpack_public_path__ + "img/globus-logo.b825be70.png";